import { SimpleGrid } from '@chakra-ui/react'

import { Span } from 'components'
import CustomFormEmptyAnswerFeedback from 'components/tools/CustomForm/commonComponents/CustomFormEmptyAnswerFeedback'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import { cepMask } from 'utils/masks'

export default function CustomFormCEPAnswer() {
  const { answer } = useCustomFormAnswer()

  const [cep, street, neighbourhood, city, state, country] = answer?.answer || []

  return (
    <CustomFormEmptyAnswerFeedback>
      <SimpleGrid columns={[1, 1, 2, 2, 2, 2]} gap={1} mt={2}>
        <Span label="CEP: " value={cepMask(cep)} />
        <Span label="Rua: " value={street} />
        <Span label="Bairro: " value={neighbourhood} />
        <Span label="Cidade: " value={city} />
        <Span label="Estado: " value={state} />
        <Span label="País: " value={country} />
      </SimpleGrid>
    </CustomFormEmptyAnswerFeedback>
  )
}
